<div class="cfg-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title"><i class="fal fa-city"></i> Villes</h1>
      <p class="page-header__sub">Référentiel géographique — {{ villes.length }} ville(s) enregistrée(s)</p>
    </div>
    <div class="header-actions">
      <button class="btn-create" (click)="ouvrirCreation()">
        <i class="fal fa-plus"></i> Nouvelle ville
      </button>
      <button class="btn-refresh" (click)="charger()" [disabled]="chargement">
        <i class="fal fa-sync" [class.fa-spin]="chargement"></i> Actualiser
      </button>
    </div>
  </div>

  <!-- KPIs -->
  <div class="kpi-row">
    <div class="kpi-card"><span class="kpi-val">{{ villes.length }}</span><span class="kpi-label">Total</span></div>
    <div class="kpi-card kpi-card--green"><span class="kpi-val">{{ actives }}</span><span class="kpi-label">Actives</span></div>
    <div class="kpi-card kpi-card--grey"><span class="kpi-val">{{ inactives }}</span><span class="kpi-label">Inactives</span></div>
  </div>

  <!-- Filtre -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltre()" placeholder="Rechercher une ville…" />
    </div>
  </div>

  <!-- Chargement -->
  <div class="etat-centre" *ngIf="chargement">
    <div class="spinner"></div><span>Chargement…</span>
  </div>

  <!-- Vide -->
  <div class="etat-centre" *ngIf="!chargement && villesFiltrees.length === 0">
    <i class="fal fa-city" style="font-size:36px;color:#cbd5e0"></i>
    <p>Aucune ville trouvée.</p>
  </div>

  <!-- Grille -->
  <div class="villes-grid" *ngIf="!chargement && villesFiltrees.length > 0">
    <div class="ville-card" *ngFor="let v of villesFiltrees">
      <div class="ville-card__top">
        <div class="ville-card__icon"><i class="fal fa-city"></i></div>
        <div class="ville-card__info">
          <strong class="ville-card__nom">{{ v.nom }}</strong>
          <p class="ville-card__desc">{{ v.description || '—' }}</p>
        </div>
        <span class="statut-badge" [ngClass]="v.actif ? 'badge--vert' : 'badge--gris'">
          {{ v.actif ? 'Active' : 'Inactive' }}
        </span>
      </div>
      <!-- Zones liées -->
      <div class="ville-card__zones" *ngIf="zonesDeVille(v.id).length > 0">
        <span class="ville-zones-label"><i class="fal fa-map-marker-alt"></i> Zones :</span>
        <div class="ville-zones-list">
          <span *ngFor="let z of zonesDeVille(v.id)" class="statut-badge badge--teal" style="font-size:11px">{{ z.nom }}</span>
        </div>
      </div>
      <div class="ville-card__zones" *ngIf="zonesDeVille(v.id).length === 0">
        <span class="ville-zones-label" style="color:#a0aec0;font-size:12px"><i class="fal fa-map-marker-alt"></i> Aucune zone associée</span>
      </div>
      <div class="ville-card__actions">
        <button class="btn-action btn-action--teal" (click)="ouvrirEdition(v)" title="Modifier">
          <i class="fal fa-pencil"></i>
        </button>
        <button class="btn-action btn-action--danger" (click)="supprimer(v)" title="Supprimer">
          <i class="fal fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL -->
<div class="modal-backdrop" *ngIf="afficherModal" (click)="fermerModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon"><i class="fal fa-city"></i></div>
        <div>
          <h3>{{ modeEdition ? 'Modifier la ville' : 'Nouvelle ville' }}</h3>
          <p class="modal-header__sub">{{ modeEdition ? 'Mettez à jour les informations' : 'Ajoutez une nouvelle ville au référentiel' }}</p>
        </div>
      </div>
      <button class="modal-close" (click)="fermerModal()"><i class="fal fa-times"></i></button>
    </div>
    <div class="modal-body">
      <div class="modal-grid">
        <div class="modal-field modal-field--full">
          <label>Nom de la ville <span class="required">*</span></label>
          <input type="text" [(ngModel)]="formulaire.nom" placeholder="Ex: Abidjan" />
        </div>
        <div class="modal-field modal-field--full">
          <label>Description</label>
          <textarea rows="2" [(ngModel)]="formulaire.description" placeholder="Informations complémentaires…"></textarea>
        </div>
        <div class="modal-field modal-field--full">
          <label class="toggle-label">
            <span>Ville active</span>
            <label class="toggle-switch">
              <input type="checkbox" [(ngModel)]="formulaire.actif" />
              <span class="toggle-slider"></span>
            </label>
          </label>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-modal-cancel" (click)="fermerModal()"><i class="fal fa-times"></i> Annuler</button>
      <button class="btn-modal-primary" (click)="sauvegarder()" [disabled]="sauvegardeEnCours">
        <ng-container *ngIf="!sauvegardeEnCours"><i class="fal fa-check"></i> {{ modeEdition ? 'Mettre à jour' : 'Créer' }}</ng-container>
        <ng-container *ngIf="sauvegardeEnCours"><div class="spinner spinner--xs spinner--white"></div> Enregistrement…</ng-container>
      </button>
    </div>
  </div>
</div>
